import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { ListPartProperties, useListPartProperties } from "./ListPartProperties";

import { DraftListPartComponent } from "./DraftListPartComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { ListPart } from "./ListPart";
import { Registry } from "../../../../base/register";

export const ListPartComponent: FC<IControlAttributes> = ({
    className, props
}) => {
    const { status, properties, error } = useListPartProperties(props)

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <>
        <ListPart {...properties}
            className={className} />
    </>
}

Registry.addControl({
    id: "281fd504-f2a0-42ab-8b7f-8f4400a7cd58",
    name: "List Part",
    type: ControlType.ListPart,
    properties: ListPartProperties,
    component: ListPartComponent,
    draftComponent: DraftListPartComponent
})
